<template>
  <div
    class="rs-spoiler"
    :style="{ 'min-height': minHeight }"
  >
    <div :class="{ disabled }" :style="{ background }" @click="handleClick">
      <slot name="header" :internalValue="internalValue">
        <div class="rs-spoiler-header">
          <div class="rs-spoiler-header-content">
            <slot name="title">{{ title }}</slot>
          </div>
        </div>
      </slot>
    </div>

    <div v-show="internalValue" class="rs-spoiler-content" :style="{ background, 'overflow-y': fitContent ? 'auto' : 'none' }">
      <slot v-if="$slots.hasOwnProperty('default')" />

      <div v-else class="rs-spoiler-content-default">
        {{ content }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default() {
        return false;
      },
    },
    title: {
      type: String,
      default() {
        return '';
      },
    },
    content: {
      type: String,
      default() {
        return '';
      },
    },
    background: {
      type: String,
      default() {
        return '#f7f8f9';
      },
    },
    disabled: {
      type: Boolean,
      default() {
        return false;
      },
    },
    fitContent: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  data() {
    return {
      internalValue: false,
    };
  },
  computed: {
    minHeight() {
      return this.fitContent && this.value ? 0 : 'auto';
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.internalValue = val;
      },
    },
  },
  methods: {
    handleClick() {
      if (this.disabled) {
        return;
      }

      const newValue = !this.internalValue;

      this.internalValue = newValue;
      this.$emit('input', newValue);
    },
  },
};
</script>

<style lang="sass" scoped>
  .rs-spoiler
    display: flex
    flex-direction: column

  .rs-spoiler-header
    display: flex
    align-items: stretch
    padding: 0 8px
    min-height: 32px
    cursor: pointer
    box-shadow: inset 0 -1px 0 0 rgba(27, 42, 48, .1)

    &.disabled
      cursor: not-allowed

  .rs-spoiler-header-content
    flex: 1
    display: flex
    align-items: center

  .rs-spoiler-content
    height: 100%
    display: flex
    flex-direction: column
    flex: 1

  .rs-spoiler-content-default
    padding: 8px
</style>
